import React from 'react';
import { Switch, Route } from 'react-router-dom';

import GridContainer from '../containers/GridContainer';
import Projects from '../containers/Projects';

/**
 * Root of a set of mutually exclusive routes, resolved from static configuration
 */
const Routes = () => {
  return (
    <Switch>
      <Route path={'/projects/:id'} component={GridContainer} />
      <Route path={'/my-projects'} component={Projects} />
      <Route path={'/'} component={Projects} />
    </Switch>
  );
};
export default Routes;



// WEBPACK FOOTER //
// ./src/routes/root.js